import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { rootReducer } from './rootReducer';
import { baseApi } from '@/lib/api/baseApi';
import { notifyApiErrors } from '@/lib/api/notifyApiErrors';

// Single Redux store for BOTH server state (RTK Query, via baseApi) and client/UI state.
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, notifyApiErrors),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);
